/**
 * WordPress dependencies
 */
import { useEffect } from '@wordpress/element';
var message = 'RichText cannot be used with an inline container. Please use a different display property.';
export function useInlineWarning(_ref) {
  var ref = _ref.ref;
  useEffect(function () {
    if (process.env.NODE_ENV === 'development') {
      var target = ref.current;
      var defaultView = target.ownerDocument.defaultView;
      var computedStyle = defaultView.getComputedStyle(target);

      if (computedStyle.display === 'inline') {
        // eslint-disable-next-line no-console
        console.error(message);
      }
    }
  }, []);
}
//# sourceMappingURL=use-inline-warning.js.map